export const AUDIO_PROXY_PATH = '/audio-proxy';
export const AUDIO_PROXY_FORWARDING_PATH = '/audio-proxy-forwarding';
